import { Box, createStyles, Group, Stack, Switch, Text } from '@mantine/core';
import React, { FC } from 'react';

import { DashboardContentLayout, useHasSupportSeat } from '@portals/framework';

import { CustomersView } from './CustomersView';
import { KpiWidgets } from './KpiWidgets';
import { SupportCenter } from './SupportCenter';
import { SupportStateProvider, useSupportState } from './SupportStateProvider';

const LabSwitch: FC = () => {
  const { isLabIncluded, setIsLabIncluded } = useSupportState();

  return (
    <Switch
      label="Include lab customers"
      checked={isLabIncluded}
      onChange={(e) => setIsLabIncluded(e.target.checked)}
    />
  );
};

export const SupportOverview: FC = () => {
  const { classes, theme } = useStyles();
  const hasSupportSeat = useHasSupportSeat();

  return (
    <SupportStateProvider>
      <DashboardContentLayout
        pageTitle={
          <Group position="apart">
            <Text inherit>Support Overview</Text>
            {hasSupportSeat ? <LabSwitch /> : null}
          </Group>
        }
        sx={{ backgroundColor: theme.colors.gray[0] }}
      >
        <Stack className={classes.container} spacing="md">
          <KpiWidgets />

          <Box className={classes.mainView}>
            <SupportCenter />

            <CustomersView />
          </Box>
        </Stack>
      </DashboardContentLayout>
    </SupportStateProvider>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    [theme.fn.largerThan('xl')]: {
      gap: theme.spacing.xl,
    },
  },
  mainView: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: theme.spacing.md,

    [theme.fn.largerThan('xl')]: {
      gap: theme.spacing.xl,
    },
  },
  mainViewItem: {
    border: `1px solid ${theme.colors.gray[2]}`,
    maxWidth: '100%',
  },
}));
